export default __webpack_public_path__ + "static/media/handImg.80abd0d9.jpg";